import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { showConfirmModal } from 'actions/global';
import { deleteList } from 'services/recruitment-apply.service';
import DataTable from 'components/shared/DataTable/index';

const RecruitmentApplyTable = ({ data, totalPages, itemsPerPage, page, totalItems, onChangePage, onRefresh }) => {
  const dispatch = useDispatch();
  const columns = useMemo(
    () => [
      {
        header: 'Tên ứng viên',
        accessor: 'full_name',
      },
      {
        header: 'Tiêu đề tin tuyển dụng',
        accessor: 'recruitment_name',
      },
      {
        header: 'Xưởng/Chi nhánh',
        accessor: 'business_name',
      },
      {
        header: 'Vị trí ứng tuyển',
        accessor: 'position_name',
      },
      {
        header: 'Ngày ứng tuyển',
        classNameHeader: 'bw_text_center',
        classNameBody: 'bw_text_center',
        accessor: 'created_date',
      },
      {
        header: 'Trạng thái',
        accessor: 'status',
        classNameHeader: 'bw_text_center',
        classNameBody: 'bw_text_center',
        formatter: (p) =>
          p?.status == 1 ? (
            <span className='bw_label_outline bw_label_outline_info text-center'>Mới ứng tuyển</span>
          ) : p?.status == 2 ? (
            <span className='bw_label_outline bw_label_outline_success text-center'>Đạt yêu cầu</span>
          ) : p?.status == 3 ? (
            <span className='bw_label_outline bw_label_outline_danger text-center'>Không đạt</span>
          ) : null,
      },
    ],
    [],
  );

  const actions = useMemo(() => {
    return [
      // {
      //   globalAction: true,
      //   icon: 'fi fi-rr-plus',
      //   type: 'success',
      //   content: 'Thêm mới',
      //   permission: 'CMS_RECRUITMENTAPPLY_ADD',
      //   onClick: () => window._$g.rdr(`/recruitment-apply/add`),
      // },
      {
        icon: 'fi fi-rr-edit',
        color: 'blue',
        title: 'Sửa',
        permission: 'CMS_RECRUITMENTAPPLY_EDIT',
        onClick: (p) => window._$g.rdr(`/recruitment-apply/edit/${p?.recruitment_apply_id}`),
      },
      {
        icon: 'fi fi-rr-eye',
        color: 'green',
        title: 'Chi tiết',
        permission: 'CMS_RECRUITMENTAPPLY_VIEW',
        onClick: (p) => window._$g.rdr(`/recruitment-apply/detail/${p?.recruitment_apply_id}`),
      },
      {
        icon: 'fi fi-rr-trash',
        color: 'red',
        title: 'Xóa',
        permission: 'CMS_RECRUITMENTAPPLY_DEL',
        onClick: (_, d) =>
          dispatch(
            showConfirmModal(
              ['Bạn có thực sự muốn xóa?', 'Bạn sẽ mất dữ liệu này và các dữ liệu liên quan.'],
              async () => {
                await deleteList([_?.recruitment_apply_id]);
                onRefresh();
              },
            ),
          ),
      },
    ];
  }, [dispatch, onRefresh]);

  return (
    <DataTable
      columns={columns}
      data={data}
      actions={actions}
      totalPages={totalPages}
      itemsPerPage={itemsPerPage}
      page={page}
      totalItems={totalItems}
      onChangePage={onChangePage}
      handleBulkAction={(e) => {
        dispatch(
          showConfirmModal(
            ['Bạn có thực sự muốn xóa?', 'Bạn sẽ mất dữ liệu này và các dữ liệu liên quan.'],
            async () => {
              await deleteList(e?.map((_) => _?.recruitment_apply_id));
              onRefresh();
            },
          ),
        );
      }}
    />
  );
};

export default RecruitmentApplyTable;
